import { render, staticRenderFns } from "./HomeWrapper.vue?vue&type=template&id=289f5ab1"
import script from "./HomeWrapper.vue?vue&type=script&lang=js"
export * from "./HomeWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports